import { Textarea } from "@nextui-org/react";
import Button from "../../../../components/Button/Button";
import useScreenSize from "../../../../hooks/useScreenSize";
import { useState } from "react";
import { feedback } from "../../../../connectors/platformFeedbackLambda";
import { useMutation } from "@tanstack/react-query";
import { addMessage } from "../../../../utils/addMessage";
import { genericErrorMessage } from "../../../../utils";

const FeedbackInput = () => {
  const { isMobile } = useScreenSize();
  const [feedbackText, setFeedbackText] = useState("");

  const handleSuccess = () => {
    addMessage({
      messageId: "layoutPage",
      message: `Feedback enviado exitosamente.`,
      type: "success",
      position: "top-right",
    });
    setFeedbackText("");
  };

  const handleError = (error: Error) => {
    addMessage({
      messageId: "layoutPage",
      message: genericErrorMessage,
      type: "error",
      position: "top-right",
    });
    console.log(error);
  };

  const { mutate, isPending } = useMutation({
    mutationFn: () => feedback({ feedback: feedbackText }),
    onSuccess: handleSuccess,
    onError: handleError,
  });

  return (
    <>
      <Textarea
        placeholder="Escribí acá tu consulta o feedback"
        variant="bordered"
        minRows={4}
        classNames={{ inputWrapper: "shadow-none h-auto" }}
        value={feedbackText}
        onValueChange={setFeedbackText}
        id="testing_phase_input"
      />

      <Button
        text="Enviar"
        className={`${!isMobile && "self-start"}`}
        onPress={() => mutate()}
        isLoading={isPending}
        disabled={!feedbackText}
      />
    </>
  );
};

export default FeedbackInput;
